import { render } from "./header-area.vue?vue&type=template&id=82de8402&scoped=true"
import script from "./header-area.vue?vue&type=script&lang=js"
export * from "./header-area.vue?vue&type=script&lang=js"

import "./header-area.vue?vue&type=style&index=0&id=82de8402&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82de8402"]])

export default __exports__